//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Grid, Typography } from '@mui/material'
import React, { ReactElement } from 'react'

import { useOtSelector } from '@react/redux/store'
import { ExchangeRateTypeEnum } from '@shared/Enums'
import { EthAddr } from '@shared/SchemaTypes'
import { PoolDynamicOverviewCTO } from '@shared/sharedTypes'
import DynamicSetCompoundingExchangeRateForm from './DynamicSetCompoundingExchangeRateForm'
import DynamicSetDynamicExchangeRateForm from './DynamicSetDynamicExchangeRateForm'
import DynamicSetLinearExchangeRateForm from './DynamicSetLinearExchangeRateForm'
import DynamicSetTermExchangeRateForm from './DynamicSetTermExchangeRateForm'
import { logOT } from '@shared/loggingShared'

export default function DynamicSetExchangeRateForm(props: { poolAddr: EthAddr; accrueMode?: boolean }): ReactElement {
  const { poolAddr, accrueMode } = props
  const poolCTO = useOtSelector((state) => state.poolState.poolOverviewCTOs[poolAddr] as PoolDynamicOverviewCTO)

  const exchangeRateType = poolCTO.exchangeRateType

  logOT.info('FOCUS: exchangeRateType', exchangeRateType)
  return (
    <div data-testid="REPAY_EARLY_REDEEM_FORM">
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Typography variant="body" align="left" sx={{ marginBottom: 2 }}>
            Dynamic Exchange rate form
          </Typography>
        </Grid>
      </Grid>
      <Grid container sx={{ marginTop: 2 }}>
        {exchangeRateType === ExchangeRateTypeEnum.Dynamic && <DynamicSetDynamicExchangeRateForm poolAddr={poolAddr} />}
        {exchangeRateType === ExchangeRateTypeEnum.Linear && <DynamicSetLinearExchangeRateForm poolAddr={poolAddr} />}
        {exchangeRateType === ExchangeRateTypeEnum.Compounding && (
          <DynamicSetCompoundingExchangeRateForm poolAddr={poolAddr} accrueMode={accrueMode} />
        )}
        {exchangeRateType === ExchangeRateTypeEnum.Term && <DynamicSetTermExchangeRateForm poolAddr={poolAddr} />}
      </Grid>
    </div>
  )
}
